export const TOKEN_KEY = "lumina_jwt";

export const setToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const isAuthenticated = () => {
    const jwt = localStorage.getItem(TOKEN_KEY);
    if (!jwt) return false;

    try {
        const parts = jwt.split(".");
        if (parts.length !== 3) return false;

        const payload = JSON.parse(atob(parts[1]));
        if (!payload.exp) return false;

        return Date.now() < payload.exp * 1000;
    } catch {
        return false;
    }
};

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);

    // Clear any other user-related data from localStorage
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("lumina_")) {
            localStorage.removeItem(key);
            i--;
        }
    }

    window.location.replace("/login");
};

export const parseJwt = (token) => {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        return JSON.parse(atob(base64));
    } catch {
        return null;
    }
};

export const getRole = () => {
    const jwt = localStorage.getItem(TOKEN_KEY);
    if (!jwt) return null;

    const payload = parseJwt(jwt);
    if (!payload) return null;

    const roles =
        payload.roles ||
        payload.authorities ||
        payload.role ||
        payload.scope ||
        null;

    if (Array.isArray(roles)) {
        return roles.includes("ROLE_ADMIN") ? "ROLE_ADMIN" : (roles[0] || null);
    }

    return roles; // ako je string
};

export const getEmail = () => {
    const jwt = localStorage.getItem(TOKEN_KEY);
    if (!jwt) return null;

    const payload = parseJwt(jwt);
    return payload?.sub || payload?.email || null;
};

export const getUserId = () => {
    const jwt = localStorage.getItem(TOKEN_KEY);
    if (!jwt) return null;

    const payload = parseJwt(jwt);
    return payload?.userId || payload?.id || null;
};

export const getDisplayName = () => {
    const jwt = localStorage.getItem(TOKEN_KEY);
    if (!jwt) return null;

    const payload = parseJwt(jwt);
    if (!payload) return null;

    if (typeof payload.exp === "number" && Date.now() >= payload.exp * 1000) {
        return null;
    }

    const fullName = [payload.firstName, payload.lastName].filter(Boolean).join(" ");
    return payload.name || payload.displayName || fullName || payload.email || null;
};
